import React from 'react';

interface WarningTextProps {
  content: string;
}

const WarningText: React.FC<WarningTextProps> = ({ content }) => {
  return (
    <div className="govuk-warning-text">
      <span className="govuk-warning-text__icon" aria-hidden="true">
        !
      </span>
      <div className="govuk-warning-text__text">
        <span className="govuk-visually-hidden">Warning</span>
        {content}
      </div>
    </div>
  );
};

export default WarningText;
